import React from 'react';
import { motion } from 'framer-motion';

const Portfolio = () => {
  const portfolioItems = [
    { 
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=300&h=200&fit=crop',
      title: 'Web Design'
    },
    { 
      image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=300&h=200&fit=crop',
      title: 'App Development'
    },
    { 
      image: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?w=300&h=200&fit=crop',
      title: 'Branding'
    },
    { 
      image: 'https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?w=300&h=200&fit=crop',
      title: 'UI/UX Design'
    },
    { 
      image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=300&h=200&fit=crop',
      title: 'Digital Marketing'
    },
    { 
      image: 'https://images.unsplash.com/photo-1553028826-f4804a6dba3b?w=300&h=200&fit=crop',
      title: 'E-commerce'
    }
  ];

  return (
    <section className="py-20 gradient-bg-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Text and image */}
          <div className="text-white">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="mb-8"
            >
              <h2 className="text-5xl font-bold mb-6">
                we<br />
                build<br />
                <span className="text-yellow-300">digital.</span>
              </h2>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2 }}
              className="relative"
            >
              <div className="bg-white rounded-full p-2 inline-block">
                <img 
                  src="https://images.unsplash.com/photo-1494790108755-2616b612b5bc?w=150&h=150&fit=crop" 
                  alt="Team member"
                  className="w-32 h-32 rounded-full object-cover"
                />
              </div>
              <p className="mt-4 text-white/90">
                "Creating digital experiences that inspire and engage users worldwide"
              </p>
            </motion.div>
          </div>

          {/* Right side - Portfolio grid */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="bg-white rounded-2xl p-6">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Our Portfolio</h3>
              <div className="grid grid-cols-2 gap-4 mb-6">
                {portfolioItems.map((item, index) => (
                  <motion.div
                    key={index}
                    whileHover={{ scale: 1.05 }}
                    className="relative group overflow-hidden rounded-lg"
                  >
                    <img 
                      src={item.image} 
                      alt={item.title}
                      className="w-full h-24 object-cover transition-transform group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                      <span className="text-white text-sm font-medium">{item.title}</span>
                    </div>
                  </motion.div>
                ))}
              </div>
              <p className="text-gray-600 text-sm mb-4">
                Explore our diverse range of creative projects and digital solutions 
                that have helped businesses achieve their goals.
              </p>
              <button className="bg-pink-500 text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-pink-600 transition-colors">
                VIEW MORE
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;